import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import InstructionsCheckbox from 'components/Input/InstructionsCheckboxInput';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import { SwitchImplementationButton } from 'components/LinkButton/LinkButton';
import { apiTokenInstructions, getProviderFormLabel } from '../utils';

const SignInPaychexFlexApi = ({
  provider,
  client,
  isLoading,
  onSubmit,
  handleClick,
  instructionsLink,
}: RegisterImplementationProps) => {
  const instructions = apiTokenInstructions(provider.displayName, client);

  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      instructions={instructions}
      instructionsLink={instructionsLink}
      divider
      onSubmit={onSubmit}
      fieldNames={[
        'instructionCheck',
        'providerClientId',
        'providerClientSecret',
      ]}
      render={({
        instructionCheck,
        providerClientId,
        providerClientSecret,
      }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <InstructionsCheckbox
                checked={instructionCheck.value}
                onChange={(checked) => instructionCheck.onChange(checked)}
              />
              <Input
                value={providerClientId.value}
                onChange={(event) =>
                  providerClientId.onChange(event.target.value)
                }
                invalid={providerClientId.invalid}
                label="Client ID"
                id="providerClientId"
              />
              <Input
                value={providerClientSecret.value}
                onChange={(event) =>
                  providerClientSecret.onChange(event.target.value)
                }
                invalid={providerClientSecret.invalid}
                label="Client Secret"
                id="providerClientSecret"
              />
            </MainContainer>
            {handleClick && (
              <SwitchImplementationButton onClick={handleClick} useNewDesign>
                Use a Username and Password instead
              </SwitchImplementationButton>
            )}
            <LoaderButton
              text="Connect"
              isLoading={isLoading}
              disabled={
                isLoading ||
                !instructionCheck.value ||
                !providerClientId.value ||
                !providerClientSecret.value
              }
              type="submit"
            />
          </>
        );
      }}
    />
  );
};

export default SignInPaychexFlexApi;
